import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import {withStyles} from "@material-ui/core";


const CustomKeyBoardPicker = withStyles({
    root: {
        width: "160px",
        background: "#FFFFFF",
        border: "1.2px solid #E2E8F0",
        boxSizing: "border-box",
        borderRadius: "4px",

        // padding: "8px",
        padding: "0 8px 0   8px",

        margin: 0,
    }
})(KeyboardDatePicker);

const CustomInputLabel = styled.div`
    margin-bottom: 8px;
    font-family: Metropolis,serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 16px;
    /* identical to box height, or 100% */
    
    display: flex;
    align-items: center;
    
    /* default/gray/600 */
    
    color: #718096;
`;

const DatePickerWrapper = styled.div`
  
`;

/**
 *
 * NB The following libraries are required to user this component:
 *  - "date-fns" & "@date-io/date-fns"
 * @param label
 * @param date
 * @param onDateChange
 * @returns {*}
 * @constructor
 */
function CustomDatePicker({label, date, onDateChange}) {
    const selectedDate = new Date(date);
    const handleDateChange = date => {
        // setSelectedDate(date);
        if (date) onDateChange(date);
    };
    return (
        <DatePickerWrapper>
            <CustomInputLabel> {label} </CustomInputLabel>

            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <CustomKeyBoardPicker
                    InputProps={
                        {
                            disableUnderline: true
                        }
                    }
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label=""
                    value={selectedDate}
                    onChange={handleDateChange}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                />
            </MuiPickersUtilsProvider>

        </DatePickerWrapper>
    );
}

CustomDatePicker.propTypes = {};
CustomDatePicker.defaultProps = {};

export default CustomDatePicker;
